import React from 'react';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { fmtArgent, fmtSemaine, LIBELLES_FREQUENCES, LIBELLES_STATUT_REGLE } from '@/lib/lmdsDeductions';

// 🧾 Phase 2 : tableau des règles de déduction (actives / désactivées / annulées) avec actions.
export function TableRegles({ regles, nomsInstallateurs, onStatut, onAnnuler }) {
  if (!regles.length) return <p className="text-sm text-slate-500 p-3" data-testid="regles-vide">Aucune règle de déduction.</p>;
  return (
    <table className="w-full text-sm" data-testid="table-regles">
      <thead className="text-xs text-slate-500 text-left">
        <tr><th className="p-2">Installateur</th><th className="p-2">Description</th><th className="p-2 text-right">Avant taxes</th><th className="p-2 text-right">Total</th>
          <th className="p-2">Fréquence</th><th className="p-2">Semaines</th><th className="p-2">Statut</th><th className="p-2"></th></tr>
      </thead>
      <tbody>
        {regles.map((r) => (
          <tr key={r.id} className="border-t" data-testid={`regle-${r.id}`}>
            <td className="p-2">{nomsInstallateurs[r.installateur_id] || r.installateur_id}</td>
            <td className="p-2">{r.description}</td>
            <td className="p-2 text-right">{fmtArgent(r.montant_avant_taxes)}</td>
            <td className="p-2 text-right font-medium">{fmtArgent(r.total)}</td>
            <td className="p-2">{LIBELLES_FREQUENCES[r.frequence]}</td>
            <td className="p-2 text-xs">{r.frequence === 'unique' ? fmtSemaine(r.semaine_cible) : `${fmtSemaine(r.semaine_debut)} → ${r.semaine_fin ? fmtSemaine(r.semaine_fin) : '∞'}`}</td>
            <td className="p-2"><Badge variant="outline" data-testid={`regle-statut-${r.id}`}>{LIBELLES_STATUT_REGLE[r.statut_regle]}</Badge></td>
            <td className="p-2 text-right whitespace-nowrap">
              {r.statut_regle !== 'annulee' && (
                <>
                  <Button size="sm" variant="outline" className="mr-1" data-testid={`regle-basculer-${r.id}`}
                    onClick={() => onStatut(r, r.statut_regle === 'active' ? 'desactivee' : 'active')}>
                    {r.statut_regle === 'active' ? 'Désactiver' : 'Réactiver'}
                  </Button>
                  <Button size="sm" variant="destructive" data-testid={`regle-annuler-${r.id}`} onClick={() => onAnnuler(r)}>Annuler</Button>
                </>
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
